export default __webpack_public_path__ + "static/media/beep.250aa10d.mp3";